import { Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { ButtonComponent } from '@shared/components/button';

@Component({
  selector: 'app-info-button',
  imports: [FontAwesomeModule, TooltipDirective, ButtonComponent],
  template: `
    @if (asButton()) {
      <ui-button
        variant="primary"
        size="sm"
        [appTooltip]="infoText()"
        [tooltipTitle]="infoTitle()"
        [tooltipPosition]="tooltipPosition()">
        <fa-icon [icon]="faCircleInfo" />
        Info
      </ui-button>
    } @else {
      <button type="button">
        <fa-icon
          class="text-primary-700"
          [appTooltip]="infoText()"
          [tooltipTitle]="infoTitle()"
          [tooltipPosition]="tooltipPosition()"
          [icon]="faCircleInfo" />
      </button>
    }
  `,
})
export class InfoButtonComponent {
  infoText = input.required<string>();
  infoTitle = input<string>('');
  tooltipPosition = input<'top' | 'bottom' | 'left' | 'right'>('top');
  asButton = input<boolean>(false);

  readonly faCircleInfo = faCircleInfo;
}
